// import React, { useState, useEffect, useRef, FormEvent, Fragment } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Nav,
//   NavItem,
//   NavLink,
//   TabContent,
//   TabPane,
//   Input,
//   InputGroup,
//   InputGroupText,
//   Form,
//   Dropdown,
//   DropdownItem,
//   DropdownMenu,
//   DropdownToggle,
//   Spinner,
// } from "reactstrap";
// import { Search, MoreVertical, Mic } from "react-feather";
// import EmojiPicker from "emoji-picker-react";
// import axios from "axios";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import { AgentSupportTitle, Support, Href } from "../../../Utils/Constants";
// import { ChatApi, ChatContactApi, ChatMembersApi } from "../../../api";
// import {
//   setAllMembers,
//   setChats,
//   setContacts,
//   searchMember,
//   changeChat,
//   createNewChatAsync,
//   fetchChatMemberAsync,
//   setSelectedUser,
//   replyByUserAsync,
//   sendMessageAsync,
// } from "../../../ReduxToolkit/Reducers/ChatReducer";
// import { RootState } from "../../../ReduxToolkit/Store";
// import {
//   AllMembersType,
//   ChatConversation,
//   ChatType,
//   MessagesType,
//   ContactParentItem,
//   ContactChildItem,
// } from "../../../Types/Chat.type";
// import { Badges, Image, LI, P, UL, Btn } from "../../../AbstractElements";
// import { dynamicImage } from "../../../Utils";
// import DashboardSvgIcon from "../../../Utils/CommonComponents/DashboardSvgIcon";
// import { apiGet, apiPost, mediaUrl } from "../../../Utils/FileUpload";
// import Echo from "laravel-echo";
// import Pusher from "pusher-js";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// interface SupportItem {
//   id: number;
//   name: string;
//   description: string;
//   ticket: string;
//   created_at: string;
//   category: string;
//   status: string;
//   file: string;
//   // Add any other properties you expect
// }
// type EchoInstance = InstanceType<typeof Echo>;

// declare global {
//   interface Window {
//     Pusher: typeof Pusher;
//     Echo: EchoInstance;
//   }
// }
// export default function AgentSupport() {
//   // Redux hooks
//   const dispatch = useDispatch();
//   // State management
//   const [activeTab, setActiveTab] = useState(1);
//   const [searchKeyword, setSearchKeyword] = useState("");
//   const [messageInput, setMessageInput] = useState("");
//   const [isResolving, setIsResolving] = useState(false);
//   const [agentSupports, setAgentSupports] = useState<SupportItem[]>([]);
//   const [agentChat, setAgentChat] = useState<any[]>([]);
//   const [selectedSupport, setSelectedSupport] = useState<SupportItem | null>(
//     null
//   );
//   const [isLoadingSupports, setIsLoadingSupports] = useState(true);
//   const [isLoadingChat, setIsLoadingChat] = useState(false);
//   // Refs
//   const chatHistoryRef = useRef<HTMLDivElement | null>(null);
//   const bottomRef = useRef<null | HTMLDivElement>(null);
//   const echoRef = useRef<EchoInstance | null>(null);
//   // Derived values
//   const activeChat =
//     selectedSupport && selectedSupport.id ? selectedSupport.id : 0;

//   const handleMessageChange = (message: string) => {
//     setMessageInput(message);
//   };

//   useEffect(() => {
//     // Initialize Pusher client
//     const pusherClient = new Pusher("dnnieup1cluc4xan8ao6", {
//       wsHost: "192.168.29.116", // Your server IP
//       wsPort: 8080,
//       forceTLS: false,
//       enabledTransports: ["ws", "wss"],
//       cluster: "mt1",
//     });

//     // Initialize Echo
//     echoRef.current = new Echo({
//       broadcaster: "pusher",
//       client: pusherClient,
//     });

//     // Listen for messages

//     echoRef.current
//       .channel(`agent_support.${selectedSupport?.id}`)
//       .listen("AgentMessageSent", (data: any) => {
//         setAgentChat((prev) => [...prev, data]);
//       });

//     return () => {
//       if (echoRef.current) {
//         echoRef.current.leave(`agent_support.${selectedSupport?.id}`);
//       }
//     };
//   }, [selectedSupport?.id]);
//   const handleMessagePress = async () => {
//     if (!messageInput.length || !selectedSupport) return;

//     try {
//       const payload = {
//         agent_support_id: selectedSupport.id,
//         message: messageInput,
//         status: "In Progress", // This will update the ticket status
//       };

//       const response = await apiPost(
//         "support_message/agentMessageStore",
//         payload
//       );
//       console.log("Message sent:", response);

//       // Refresh the chat messages after sending
//       fetchAgentChatById(selectedSupport.id);

//       // Update local state to reflect status change
//       if (selectedSupport.status !== "In Progress") {
//         setSelectedSupport((prev) =>
//           prev ? { ...prev, status: "In Progress" } : null
//         );
//         setAgentSupports((prev) =>
//           prev.map((item) =>
//             item.id === selectedSupport.id
//               ? { ...item, status: "In Progress" }
//               : item
//           )
//         );
//       }

//       setMessageInput("");
//     } catch (error) {
//       console.error("Error sending message:", error);
//     }
//   };

//   const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     handleMessagePress();
//   };

//   const changeChatClick = (supportItem: any) => {
//     setSelectedSupport(supportItem);
//     fetchAgentChatById(supportItem.id);
//   };

//   const handleSearchKeyword = (keyword: string) => {
//     setSearchKeyword(keyword);
//     // Filter agent supports based on search keyword
//     const filtered = agentSupports.filter(
//       (item: any) =>
//         item.name.toLowerCase().includes(keyword.toLowerCase()) ||
//         item.category.toLowerCase().includes(keyword.toLowerCase()) ||
//         item.description.toLowerCase().includes(keyword.toLowerCase()) ||
//         item.ticket.includes(keyword)
//     );
//   };

//   // API functions
//   const fetchChatApiData = async () => {
//     try {
//       const response = await axios.get(ChatApi);
//       dispatch(setChats(response.data.data));
//     } catch (error) {
//       console.error("data not fetched", error);
//     }
//   };

//   const fetchChatMemberApiData = async () => {
//     try {
//       const response = await axios.get(ChatMembersApi);
//       dispatch(setAllMembers(response.data));
//       return response.data;
//     } catch (error) {
//       console.error("data not fetched", error);
//     }
//   };

//   const fetchChatContactApiData = async () => {
//     try {
//       const response = await axios.get(ChatContactApi);
//       dispatch(setContacts(response.data));
//     } catch (error) {
//       console.error("data not fetched", error);
//     }
//   };

//   const fetchAgentChatById = async (supportId: number) => {
//     setIsLoadingChat(true);
//     try {
//       const payload = {
//         agent_support_id: supportId,
//       };
//       const response = await apiPost("agent_supportmessage/get", payload);
//       setAgentChat(response.data || response);
//     } catch (err) {
//       console.error("Error fetching agent chat:", err);
//     } finally {
//       setIsLoadingChat(false);
//     }
//   };

//   // Effects
//   useEffect(() => {
//     fetchChatApiData();
//     fetchChatMemberApiData();
//     fetchChatContactApiData();
//   }, []);

//   useEffect(() => {
//     if (chatHistoryRef.current) {
//       chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
//     }
//   }, [agentChat]);

//   useEffect(() => {
//     const fetchAgentSupports = async () => {
//       setIsLoadingSupports(true);
//       try {
//         const response = await apiGet("agent_support_getall");
//         console.log("API Response:", response);
//         const supportsData = response.data || response;
//         setAgentSupports(supportsData);

//         // Don't auto-select any support item - keep right side empty initially
//       } catch (err) {
//         console.error("Error fetching agent supports:", err);
//       } finally {
//         setIsLoadingSupports(false);
//       }
//     };

//     fetchAgentSupports();
//   }, []);

//   // Filter agent supports based on search
//   const filteredAgentSupports = agentSupports.filter(
//     (item: any) =>
//       item.name.toLowerCase().includes(searchKeyword.toLowerCase()) ||
//       item.category.toLowerCase().includes(searchKeyword.toLowerCase()) ||
//       item.description.toLowerCase().includes(searchKeyword.toLowerCase()) ||
//       item.ticket.includes(searchKeyword)
//   );

//   const handleResolveTicket = async () => {
//     if (!selectedSupport) return;

//     setIsResolving(true);
//     try {
//       const response = await apiPost("agent_support/resolve", {
//         id: selectedSupport.id,
//         status: "Resolved",
//       });

//       // Update local state - with proper null checks
//       setSelectedSupport((prev) => {
//         if (!prev) return null;
//         return { ...prev, status: "Resolved" };
//       });

//       setAgentSupports((prev) =>
//         prev.map((item) =>
//           item.id === selectedSupport.id
//             ? { ...item, status: "Resolved" }
//             : item
//         )
//       );

//       console.log("Ticket resolved:", response);
//     } catch (error) {
//       console.error("Error resolving ticket:", error);
//     } finally {
//       setIsResolving(false);
//     }
//   };

//   return (
//     <>
//       <Breadcrumbs
//         pageTitle={AgentSupportTitle}
//         parent={Support}
//         title={AgentSupportTitle}
//       />
//       <Row className="g-0">
//         <Col xxl={3} xl={4} md={5} className="box-col-5">
//           <Card className="left-sidebar-wrapper">
//             <div className="left-sidebar-chat">
//               <InputGroup>
//                 <InputGroupText>
//                   <Search className="search-icon text-gray" />
//                 </InputGroupText>
//                 <Input
//                   type="text"
//                   placeholder="Search here.."
//                   value={searchKeyword}
//                   onChange={(e) => handleSearchKeyword(e.target.value)}
//                 />
//               </InputGroup>
//             </div>
//             <div className="advance-options">
//               {isLoadingSupports ? (
//                 <div className="p-6">
//                   {[...Array(5)].map((_, i) => (
//                     <div key={i} className="mb-3">
//                       <Skeleton width={280} height={50} />
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <TabContent activeTab={activeTab}>
//                   <TabPane tabId={1}>
//                     <>
//                       {filteredAgentSupports &&
//                       filteredAgentSupports.length > 0 ? (
//                         <UL className="chats-user simple-list">
//                           {filteredAgentSupports.map((item: any, i: number) => {
//                             return (
//                               <LI
//                                 key={i}
//                                 className={`common-space ${
//                                   activeChat === item.id && "active"
//                                 }`}
//                                 onClick={() => changeChatClick(item)}
//                               >
//                                 <div className="chat-time">
//                                   <div className="active-profile">
//                                     <Image
//                                       src={dynamicImage("userpic.png")}
//                                       className="img-fluid rounded-circle"
//                                       alt=""
//                                     />
//                                   </div>
//                                   <div>
//                                     <p style={{ fontSize: "15px" }}>
//                                       <b>{item.name}</b>
//                                     </p>
//                                     <P>{item.description}</P>
//                                   </div>
//                                 </div>
//                                 <div>
//                                   <P>{item.ticket}</P>
//                                 </div>
//                               </LI>
//                             );
//                           })}
//                         </UL>
//                       ) : (
//                         <div
//                           className="text-center m-6 p-6"
//                           style={{ margin: "10%" }}
//                         >
//                           {"No Agent Support Present"}
//                         </div>
//                       )}
//                     </>
//                   </TabPane>
//                 </TabContent>
//               )}
//             </div>
//           </Card>
//         </Col>
//         <Col xxl={9} xl={8} md={7} className="box-col-7">
//           <Card className="right-sidebar-chat">
//             {selectedSupport ? (
//               // Show chat interface when support ticket is selected
//               <>
//                 <div className="right-sidebar-title">
//                   <div className="common-space">
//                     <div className="chat-time">
//                       <div className="active-profile">
//                         <Image
//                           className="img-fluid rounded-circle"
//                           src={dynamicImage("profile.png")}
//                           alt="user"
//                         />
//                       </div>
//                       <div>
//                         <span>{selectedSupport.name}</span>
//                       </div>
//                     </div>
//                     <div className="d-flex gap-2">
//                       <div className="d-flex gap-2">
//                         {selectedSupport?.status === "Resolved" ? (
//                           <div className="text-success fw-bold">
//                             <i className="fa fa-check-circle me-2"></i>
//                             Resolved
//                           </div>
//                         ) : (
//                           <button
//                             className="btn btn-success btn-sm"
//                             onClick={handleResolveTicket}
//                             disabled={isResolving}
//                           >
//                             {isResolving ? (
//                               <>
//                                 <span className="spinner-border spinner-border-sm me-2"></span>
//                                 Resolving...
//                               </>
//                             ) : (
//                               <>
//                                 <i className="fa fa-check-circle me-2"></i>
//                                 Resolve Ticket
//                               </>
//                             )}
//                           </button>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="right-sidebar-Chats">
//                   <div className="msger">
//                     <div className="msger-chat" ref={chatHistoryRef}>
//                       {isLoadingChat ? (
//                         <div
//                           className="text-center p-5"
//                           style={{ marginTop: "15%" }}
//                         >
//                           <Spinner color="primary" />
//                           <p className="mt-2">Loading conversation...</p>
//                         </div>
//                       ) : (
//                         <>
//                           {selectedSupport && (
//                             <div
//                               className="support-ticket-header mb-4 p-3 rounded"
//                               style={{
//                                 backgroundColor: "#f8f9fa",
//                                 borderLeft: "4px solid #7366ff",
//                               }}
//                             >
//                               <div className="d-flex justify-content-between align-items-start">
//                                 <div>
//                                   <h5 className="mb-2">
//                                     <span className="badge bg-primary me-2">
//                                       #{selectedSupport.ticket}
//                                     </span>
//                                     {selectedSupport.name}
//                                   </h5>
//                                   <div className="d-flex flex-wrap gap-3 mb-2">
//                                     <div>
//                                       <small className="text-muted">
//                                         Category
//                                       </small>
//                                       <div className="fw-bold">
//                                         {selectedSupport.category}
//                                       </div>
//                                     </div>
//                                     <div>
//                                       <small className="text-muted">
//                                         Status
//                                       </small>
//                                       <div>
//                                         <span
//                                           className={`badge bg-${
//                                             selectedSupport.status === "New"
//                                               ? "warning"
//                                               : selectedSupport.status ===
//                                                 "In Progress"
//                                               ? "info"
//                                               : selectedSupport.status ===
//                                                 "Resolved"
//                                               ? "success"
//                                               : "secondary"
//                                           }`}
//                                         >
//                                           {selectedSupport.status}
//                                         </span>
//                                       </div>
//                                     </div>
//                                     <div>
//                                       <small className="text-muted">
//                                         Created
//                                       </small>
//                                       <div className="fw-bold">
//                                         {new Date(
//                                           selectedSupport.created_at
//                                         ).toLocaleDateString()}
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                                 {selectedSupport.file && (
//                                   <div className="text-end">
//                                     <a
//                                       href={`${mediaUrl}/${selectedSupport.file}`}
//                                       target="_blank"
//                                       rel="noopener noreferrer"
//                                       className="btn btn-sm btn-outline-primary"
//                                     >
//                                       <i className="fa fa-paperclip me-1"></i>{" "}
//                                       View Attachment
//                                     </a>
//                                   </div>
//                                 )}
//                               </div>

//                               <div className="mt-3">
//                                 <small className="text-muted">
//                                   Description
//                                 </small>
//                                 <div className="p-3 bg-white rounded">
//                                   {selectedSupport.description}
//                                 </div>
//                               </div>
//                             </div>
//                           )}
//                           {agentChat && agentChat.length > 0 ? (
//                             agentChat.map((item: any, index: number) => {
//                               const isAgent = item.agent_id !== null;
//                               return (
//                                 <div
//                                   className={`msg ${
//                                     isAgent ? "left" : "right"
//                                   }-msg`}
//                                   key={index}
//                                 >
//                                   <div className="msg-img">
//                                     <Image
//                                       src={dynamicImage(
//                                         isAgent ? "userpic.png" : "profile.png"
//                                       )}
//                                       className={`rounded-circle ${
//                                         isAgent ? "float-start" : "float-end"
//                                       } chat-user-img img-30 h-auto`}
//                                       alt=""
//                                     />
//                                   </div>
//                                   <div className="msg-bubble">
//                                     <div className="msg-info">
//                                       <div className="msg-info-name">
//                                         {isAgent
//                                           ? selectedSupport?.name || "Agent"
//                                           : "Admin"}
//                                       </div>
//                                       <div className="msg-info-time">
//                                         {new Date(
//                                           item.created_at
//                                         ).toLocaleTimeString()}
//                                       </div>
//                                     </div>
//                                     <div className="msg-text">
//                                       {item.message}
//                                     </div>
//                                   </div>
//                                 </div>
//                               );
//                             })
//                           ) : (
//                             <div className="text-center p-4">
//                               <Image
//                                 className="img-fluid mb-3"
//                                 src={dynamicImage("start-conversion.jpg")}
//                                 alt="start conversation"
//                                 style={{ maxWidth: "200px" }}
//                               />
//                               <h5>Start the conversation</h5>
//                               <p className="text-muted">
//                                 Send a message to begin support chat
//                               </p>
//                             </div>
//                           )}
//                         </>
//                       )}
//                       <div ref={bottomRef}></div>
//                     </div>
//                     <Form
//                       className="msger-inputarea"
//                       onSubmit={(e) => handleSubmit(e)}
//                     >
//                       <Input
//                         type="text"
//                         className="msger-input two uk-textarea"
//                         placeholder="Type a message......"
//                         value={messageInput}
//                         onChange={(e) => handleMessageChange(e.target.value)}
//                       />
//                       <Btn
//                         color="primary"
//                         className="msger-send-btn"
//                         disabled={
//                           !messageInput.trim() ||
//                           selectedSupport?.status === "Resolved"
//                         }
//                         style={{ width: "10%" }}
//                       >
//                         Send <i className="fa-solid fa-location-arrow" />
//                       </Btn>
//                     </Form>
//                   </div>
//                 </div>
//               </>
//             ) : (
//               // Show empty state when no support ticket is selected (like WhatsApp Web)
//               <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center p-5">
//                 <div className="mb-4">
//                   <i
//                     className="fa-solid fa-comments"
//                     style={{ fontSize: "4rem", color: "#ddd" }}
//                   ></i>
//                 </div>
//                 <h3 className="mb-3 text-muted">Agent Support Chat</h3>
//                 <p className="text-muted mb-4" style={{ maxWidth: "400px" }}>
//                   Select a support ticket from the list to start viewing and
//                   responding to customer inquiries.
//                 </p>
//                 <div className="text-muted">
//                   <small>
//                     💡 Tip: Click on any support ticket on the left to begin the
//                     conversation
//                   </small>
//                 </div>
//               </div>
//             )}
//           </Card>
//         </Col>
//       </Row>
//     </>
//   );
// }

////withoutevent
import React, { useState, useEffect, useRef, FormEvent, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Container,
  Row,
  Col,
  Card,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  InputGroupText,
  Form,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
import { Search, MoreVertical, Mic } from "react-feather";
import EmojiPicker from "emoji-picker-react";
import axios from "axios";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import { AgentSupportTitle, Support, Href } from "../../../Utils/Constants";
import { ChatApi, ChatContactApi, ChatMembersApi } from "../../../api";
import {
  setAllMembers,
  setChats,
  setContacts,
  searchMember,
  changeChat,
  createNewChatAsync,
  fetchChatMemberAsync,
  setSelectedUser,
  replyByUserAsync,
  sendMessageAsync,
} from "../../../ReduxToolkit/Reducers/ChatReducer";
import { RootState } from "../../../ReduxToolkit/Store";
import {
  AllMembersType,
  ChatConversation,
  ChatType,
  MessagesType,
  ContactParentItem,
  ContactChildItem,
} from "../../../Types/Chat.type";
import { Badges, Image, LI, P, UL, Btn } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import DashboardSvgIcon from "../../../Utils/CommonComponents/DashboardSvgIcon";
import { apiGet, apiPost, mediaUrl } from "../../../Utils/FileUpload";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
interface SupportItem {
  id: number;
  name: string;
  description: string;
  ticket: string;
  created_at: string;
  category: string;
  status: string;
  file: string;
  // Add any other properties you expect
}

export default function AgentSupport() {
  // Redux hooks
  const dispatch = useDispatch();
  const { chatContact, members, currentUser, selectedUser, chats, allMembers } =
    useSelector((state: RootState) => state.chat);

  // State management
  const [activeTab, setActiveTab] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [messageInput, setMessageInput] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [isResolving, setIsResolving] = useState(false);
  const [agentSupports, setAgentSupports] = useState<SupportItem[]>([]);
  const [agentChat, setAgentChat] = useState<any[]>([]);
  const [selectedSupport, setSelectedSupport] = useState<SupportItem | null>(
    null
  );
  const [isLoadingSupports, setIsLoadingSupports] = useState(true);
  const [isLoadingChat, setIsLoadingChat] = useState(false);
  // Refs
  const chatHistoryRef = useRef<HTMLDivElement | null>(null);
  const bottomRef = useRef<null | HTMLDivElement>(null);

  // Derived values
  const activeChat =
    selectedSupport && selectedSupport.id ? selectedSupport.id : 0;

  // Helper functions
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const toggledrop = () => setDropdown(!dropdown);

  const addEmoji = (emoji: string) => {
    const text = `${messageInput}${emoji}`;
    setShowEmojiPicker(false);
    setMessageInput(text);
  };

  const handleMessageChange = (message: string) => {
    setMessageInput(message);
  };

  const handleMessagePress = async () => {
    if (!messageInput.length || !selectedSupport) return;

    try {
      const payload = {
        agent_support_id: selectedSupport.id,
        message: messageInput,
        status: "In Progress", // This will update the ticket status
      };

      const response = await apiPost(
        "support_message/agentMessageStore",
        payload
      );
      console.log("Message sent:", response);

      // Refresh the chat messages after sending
      fetchAgentChatById(selectedSupport.id);

      // Update local state to reflect status change
      if (selectedSupport.status !== "In Progress") {
        setSelectedSupport((prev) =>
          prev ? { ...prev, status: "In Progress" } : null
        );
        setAgentSupports((prev) =>
          prev.map((item) =>
            item.id === selectedSupport.id
              ? { ...item, status: "In Progress" }
              : item
          )
        );
      }

      setMessageInput("");
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleMessagePress();
  };

  const changeChatClick = (supportItem: any) => {
    setSelectedSupport(supportItem);
    fetchAgentChatById(supportItem.id);
  };

  const handleSearchKeyword = (keyword: string) => {
    setSearchKeyword(keyword);
    // Filter agent supports based on search keyword
    const filtered = agentSupports.filter(
      (item: any) =>
        item.name.toLowerCase().includes(keyword.toLowerCase()) ||
        item.category.toLowerCase().includes(keyword.toLowerCase()) ||
        item.description.toLowerCase().includes(keyword.toLowerCase()) ||
        item.ticket.includes(keyword)
    );
  };

  // API functions
  const fetchChatApiData = async () => {
    try {
      const response = await axios.get(ChatApi);
      dispatch(setChats(response.data.data));
    } catch (error) {
      console.error("data not fetched", error);
    }
  };

  const fetchChatMemberApiData = async () => {
    try {
      const response = await axios.get(ChatMembersApi);
      dispatch(setAllMembers(response.data));
      return response.data;
    } catch (error) {
      console.error("data not fetched", error);
    }
  };

  const fetchChatContactApiData = async () => {
    try {
      const response = await axios.get(ChatContactApi);
      dispatch(setContacts(response.data));
    } catch (error) {
      console.error("data not fetched", error);
    }
  };

  const fetchAgentChatById = async (supportId: number) => {
    setIsLoadingChat(true);
    try {
      const payload = {
        agent_support_id: supportId,
      };
      const response = await apiPost("agent_supportmessage/get", payload);
      setAgentChat(response.data || response);
    } catch (err) {
      console.error("Error fetching agent chat:", err);
    } finally {
      setIsLoadingChat(false);
    }
  };

  // Effects
  useEffect(() => {
    fetchChatApiData();
    fetchChatMemberApiData();
    fetchChatContactApiData();
  }, []);

  useEffect(() => {
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
    }
  }, [agentChat]);

  useEffect(() => {
    const fetchAgentSupports = async () => {
      setIsLoadingSupports(true);
      try {
        const response = await apiGet("agent_support_getall");
        console.log("API Response:", response);
        const supportsData = response.data || response;
        setAgentSupports(supportsData);

        // Don't auto-select any support item - keep right side empty initially
      } catch (err) {
        console.error("Error fetching agent supports:", err);
      } finally {
        setIsLoadingSupports(false);
      }
    };

    fetchAgentSupports();
  }, []);

  // Filter agent supports based on search
  const filteredAgentSupports = agentSupports.filter(
    (item: any) =>
      item.name.toLowerCase().includes(searchKeyword.toLowerCase()) ||
      item.category.toLowerCase().includes(searchKeyword.toLowerCase()) ||
      item.description.toLowerCase().includes(searchKeyword.toLowerCase()) ||
      item.ticket.includes(searchKeyword)
  );

  const handleResolveTicket = async () => {
    if (!selectedSupport) return;

    setIsResolving(true);
    try {
      const response = await apiPost("agent_support/resolve", {
        id: selectedSupport.id,
        status: "Resolved",
      });

      // Update local state - with proper null checks
      setSelectedSupport((prev) => {
        if (!prev) return null;
        return { ...prev, status: "Resolved" };
      });

      setAgentSupports((prev) =>
        prev.map((item) =>
          item.id === selectedSupport.id
            ? { ...item, status: "Resolved" }
            : item
        )
      );

      console.log("Ticket resolved:", response);
    } catch (error) {
      console.error("Error resolving ticket:", error);
    } finally {
      setIsResolving(false);
    }
  };

  return (
    <>
      <Breadcrumbs
        pageTitle={AgentSupportTitle}
        parent={Support}
        title={AgentSupportTitle}
      />
      <Row className="g-0">
        <Col xxl={3} xl={4} md={5} className="box-col-5">
          <Card className="left-sidebar-wrapper">
            <div className="left-sidebar-chat">
              <InputGroup>
                <InputGroupText>
                  <Search className="search-icon text-gray" />
                </InputGroupText>
                <Input
                  type="text"
                  placeholder="Search here.."
                  value={searchKeyword}
                  onChange={(e) => handleSearchKeyword(e.target.value)}
                />
              </InputGroup>
            </div>
            <div className="advance-options">
              {isLoadingSupports ? (
                <div className="p-6">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="mb-3">
                      <Skeleton width={280} height={50} />
                    </div>
                  ))}
                </div>
              ) : (
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={1}>
                    <>
                      {filteredAgentSupports &&
                      filteredAgentSupports.length > 0 ? (
                        <UL className="chats-user simple-list">
                          {filteredAgentSupports.map((item: any, i: number) => {
                            return (
                              <LI
                                key={i}
                                className={`common-space ${
                                  activeChat === item.id && "active"
                                }`}
                                onClick={() => changeChatClick(item)}
                              >
                                <div className="chat-time">
                                  <div className="active-profile">
                                    <Image
                                      src={dynamicImage("userpic.png")}
                                      className="img-fluid rounded-circle"
                                      alt=""
                                    />
                                  </div>
                                  <div>
                                    <p style={{ fontSize: "15px" }}>
                                      <b>{item.name}</b>
                                    </p>
                                    <P>{item.description}</P>
                                  </div>
                                </div>
                                <div>
                                  <P>{item.ticket}</P>
                                </div>
                              </LI>
                            );
                          })}
                        </UL>
                      ) : (
                        <div
                          className="text-center m-6 p-6"
                          style={{ margin: "10%" }}
                        >
                          {"No Agent Support Present"}
                        </div>
                      )}
                    </>
                  </TabPane>
                </TabContent>
              )}
            </div>
          </Card>
        </Col>
        <Col xxl={9} xl={8} md={7} className="box-col-7">
          <Card className="right-sidebar-chat">
            {selectedSupport ? (
              // Show chat interface when support ticket is selected
              <>
                <div className="right-sidebar-title">
                  <div className="common-space">
                    <div className="chat-time">
                      <div className="active-profile">
                        <Image
                          className="img-fluid rounded-circle"
                          src={dynamicImage("profile.png")}
                          alt="user"
                        />
                      </div>
                      <div>
                        <span>{selectedSupport.name}</span>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <div className="d-flex gap-2">
                        {selectedSupport?.status === "Resolved" ? (
                          <div className="text-success fw-bold">
                            <i className="fa fa-check-circle me-2"></i>
                            Resolved
                          </div>
                        ) : (
                          <button
                            className="btn btn-success btn-sm"
                            onClick={handleResolveTicket}
                            disabled={isResolving}
                          >
                            {isResolving ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Resolving...
                              </>
                            ) : (
                              <>
                                <i className="fa fa-check-circle me-2"></i>
                                Resolve Ticket
                              </>
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="right-sidebar-Chats">
                  <div className="msger">
                    <div className="msger-chat" ref={chatHistoryRef}>
                      {isLoadingChat ? (
                        <div
                          className="text-center p-5"
                          style={{ marginTop: "15%" }}
                        >
                          <Spinner color="primary" />
                          <p className="mt-2">Loading conversation...</p>
                        </div>
                      ) : (
                        <>
                          {selectedSupport && (
                            <div
                              className="support-ticket-header mb-4 p-3 rounded"
                              style={{
                                backgroundColor: "#f8f9fa",
                                borderLeft: "4px solid #7366ff",
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <h5 className="mb-2">
                                    <span className="badge bg-primary me-2">
                                      #{selectedSupport.ticket}
                                    </span>
                                    {selectedSupport.name}
                                  </h5>
                                  <div className="d-flex flex-wrap gap-3 mb-2">
                                    <div>
                                      <small className="text-muted">
                                        Category
                                      </small>
                                      <div className="fw-bold">
                                        {selectedSupport.category}
                                      </div>
                                    </div>
                                    <div>
                                      <small className="text-muted">
                                        Status
                                      </small>
                                      <div>
                                        <span
                                          className={`badge bg-${
                                            selectedSupport.status === "New"
                                              ? "warning"
                                              : selectedSupport.status ===
                                                "In Progress"
                                              ? "info"
                                              : selectedSupport.status ===
                                                "Resolved"
                                              ? "success"
                                              : "secondary"
                                          }`}
                                        >
                                          {selectedSupport.status}
                                        </span>
                                      </div>
                                    </div>
                                    <div>
                                      <small className="text-muted">
                                        Created
                                      </small>
                                      <div className="fw-bold">
                                        {new Date(
                                          selectedSupport.created_at
                                        ).toLocaleDateString()}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {selectedSupport.file && (
                                  <div className="text-end">
                                    <a
                                      href={`${mediaUrl}/${selectedSupport.file}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn btn-sm btn-outline-primary"
                                    >
                                      <i className="fa fa-paperclip me-1"></i>{" "}
                                      View Attachment
                                    </a>
                                  </div>
                                )}
                              </div>

                              <div className="mt-3">
                                <small className="text-muted">
                                  Description
                                </small>
                                <div className="p-3 bg-white rounded">
                                  {selectedSupport.description}
                                </div>
                              </div>
                            </div>
                          )}
                          {agentChat && agentChat.length > 0 ? (
                            agentChat.map((item: any, index: number) => {
                              const isAgent = item.agent_id !== null;
                              return (
                                <div
                                  className={`msg ${
                                    isAgent ? "left" : "right"
                                  }-msg`}
                                  key={index}
                                >
                                  <div className="msg-img">
                                    <Image
                                      src={dynamicImage(
                                        isAgent ? "userpic.png" : "profile.png"
                                      )}
                                      className={`rounded-circle ${
                                        isAgent ? "float-start" : "float-end"
                                      } chat-user-img img-30 h-auto`}
                                      alt=""
                                    />
                                  </div>
                                  <div className="msg-bubble">
                                    <div className="msg-info">
                                      <div className="msg-info-name">
                                        {isAgent
                                          ? selectedSupport?.name || "Agent"
                                          : "Admin"}
                                      </div>
                                      <div className="msg-info-time">
                                        {new Date(
                                          item.created_at
                                        ).toLocaleTimeString()}
                                      </div>
                                    </div>
                                    <div className="msg-text">
                                      {item.message}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div className="text-center p-4">
                              <Image
                                className="img-fluid mb-3"
                                src={dynamicImage("start-conversion.jpg")}
                                alt="start conversation"
                                style={{ maxWidth: "200px" }}
                              />
                              <h5>Start the conversation</h5>
                              <p className="text-muted">
                                Send a message to begin support chat
                              </p>
                            </div>
                          )}
                        </>
                      )}
                      <div ref={bottomRef}></div>
                    </div>
                    <Form
                      className="msger-inputarea"
                      onSubmit={(e) => handleSubmit(e)}
                    >
                      <Input
                        type="text"
                        className="msger-input two uk-textarea"
                        placeholder="Type a message......"
                        value={messageInput}
                        onChange={(e) => handleMessageChange(e.target.value)}
                      />
                      <Btn
                        color="primary"
                        className="msger-send-btn"
                        disabled={
                          !messageInput.trim() ||
                          selectedSupport?.status === "Resolved"
                        }
                        style={{ width: "10%" }}
                      >
                        Send <i className="fa-solid fa-location-arrow" />
                      </Btn>
                    </Form>
                  </div>
                </div>
              </>
            ) : (
              // Show empty state when no support ticket is selected (like WhatsApp Web)
              <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center p-5">
                <div className="mb-4">
                  <i
                    className="fa-solid fa-comments"
                    style={{ fontSize: "4rem", color: "#ddd" }}
                  ></i>
                </div>
                <h3 className="mb-3 text-muted">Agent Support Chat</h3>
                <p className="text-muted mb-4" style={{ maxWidth: "400px" }}>
                  Select a support ticket from the list to start viewing and
                  responding to customer inquiries.
                </p>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
}

// import React, { useState, useEffect, useRef, FormEvent, Fragment } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Nav,
//   NavItem,
//   NavLink,
//   TabContent,
//   TabPane,
//   Input,
//   InputGroup,
//   InputGroupText,
//   Form,
//   Dropdown,
//   DropdownItem,
//   DropdownMenu,
//   DropdownToggle,
// } from "reactstrap";
// import { Search, MoreVertical, Mic } from "react-feather";
// import EmojiPicker from "emoji-picker-react";
// import axios from "axios";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import { AgentSupportTitle, Support, Href } from "../../../Utils/Constants";
// import { ChatApi, ChatContactApi, ChatMembersApi } from "../../../api";
// import {
//   setAllMembers,
//   setChats,
//   setContacts,
//   searchMember,
//   changeChat,
//   createNewChatAsync,
//   fetchChatMemberAsync,
//   setSelectedUser,
//   replyByUserAsync,
//   sendMessageAsync,
// } from "../../../ReduxToolkit/Reducers/ChatReducer";
// import { RootState } from "../../../ReduxToolkit/Store";
// import {
//   AllMembersType,
//   ChatConversation,
//   ChatType,
//   MessagesType,
//   ContactParentItem,
//   ContactChildItem,
// } from "../../../Types/Chat.type";
// import { Badges, Image, LI, P, UL, Btn } from "../../../AbstractElements";
// import { dynamicImage } from "../../../Utils";
// import DashboardSvgIcon from "../../../Utils/CommonComponents/DashboardSvgIcon";
// import { apiGet, apiPost, mediaUrl } from "../../../Utils/FileUpload";

// interface SupportItem {
//   id: number;
//   name: string;
//   description: string;
//   ticket: string;
//   created_at: string;
//   category:string;
//   status:string;
//   file:string;
//   // Add any other properties you expect
// }

// export default function AgentSupport() {
//   // Redux hooks
//   const dispatch = useDispatch();
//   const { chatContact, members, currentUser, selectedUser, chats, allMembers } =
//     useSelector((state: RootState) => state.chat);

//   // State management
//   const [activeTab, setActiveTab] = useState(1);
//   const [searchKeyword, setSearchKeyword] = useState("");
//   const [messageInput, setMessageInput] = useState("");
//   const [showEmojiPicker, setShowEmojiPicker] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [dropdown, setDropdown] = useState(false);
//   const [scroll, setScroll] = useState(0);
//   const [agentSupports, setAgentSupports] = useState<SupportItem[]>([]);
//   const [agentChat, setAgentChat] = useState<any[]>([]);
//   const [selectedSupport, setSelectedSupport] = useState<SupportItem | null>(
//     null
//   );

//    // Refs
//   const chatHistoryRef = useRef<HTMLDivElement | null>(null);
//   const bottomRef = useRef<null | HTMLDivElement>(null);

//   // Derived values
//   const activeChat =
//     selectedSupport && selectedSupport.id
//       ? selectedSupport.id
//       : 0;

//   // Helper functions
//   const toggle = () => setDropdownOpen((prevState) => !prevState);
//   const toggledrop = () => setDropdown(!dropdown);

//   const addEmoji = (emoji: string) => {
//     const text = `${messageInput}${emoji}`;
//     setShowEmojiPicker(false);
//     setMessageInput(text);
//   };

//   const handleMessageChange = (message: string) => {
//     setMessageInput(message);
//   };

//   const handleMessagePress = async () => {
//     if (!messageInput.length || !selectedSupport) return;

//     try {
//       const payload = {
//         agent_support_id: selectedSupport.id,
//         message: messageInput
//       };

//       const response = await apiPost("support_message/agentMessageStore", payload);
//       console.log("Message sent:", response);

//       // Refresh the chat messages after sending
//       fetchAgentChatById(selectedSupport.id);
//       setMessageInput("");
//     } catch (error) {
//       console.error("Error sending message:", error);
//     }
//   };

//   const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     handleMessagePress();
//   };

//   const changeChatClick = (supportItem: any) => {
//     setSelectedSupport(supportItem);
//     fetchAgentChatById(supportItem.id);
//   };

//   const handleSearchKeyword = (keyword: string) => {
//     setSearchKeyword(keyword);
//     // Filter agent supports based on search keyword
//     const filtered = agentSupports.filter((item: any) =>
//       item.name.toLowerCase().includes(keyword.toLowerCase()) ||
//       item.category.toLowerCase().includes(keyword.toLowerCase()) ||
//       item.description.toLowerCase().includes(keyword.toLowerCase()) ||
//       item.ticket.includes(keyword)
//     );
//   };

//   // API functions
//   const fetchChatApiData = async () => {
//     try {
//       const response = await axios.get(ChatApi);
//       dispatch(setChats(response.data.data));
//     } catch (error) {
//       console.error("data not fetched", error);
//     }
//   };

//   const fetchChatMemberApiData = async () => {
//     try {
//       const response = await axios.get(ChatMembersApi);
//       dispatch(setAllMembers(response.data));
//       return response.data;
//     } catch (error) {
//       console.error("data not fetched", error);
//     }
//   };

//   const fetchChatContactApiData = async () => {
//     try {
//       const response = await axios.get(ChatContactApi);
//       dispatch(setContacts(response.data));
//     } catch (error) {
//       console.error("data not fetched", error);
//     }
//   };

//   const fetchAgentChatById = async (supportId: number) => {
//     try {
//       const payload = {
//         agent_support_id: supportId,
//       };
//       const response = await apiPost("agent_supportmessage/get", payload);
//       console.log(response.data, "response");
//       setAgentChat(response.data || response);
//     } catch (err) {
//       console.error("Error fetching agent chat:", err);
//     }
//   };

//   // Effects
//   useEffect(() => {
//     fetchChatApiData();
//     fetchChatMemberApiData();
//     fetchChatContactApiData();
//   }, []);

//   useEffect(() => {
//     if (chatHistoryRef.current) {
//       chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
//     }
//   }, [agentChat]);

//   useEffect(() => {
//     const fetchAgentSupports = async () => {
//       try {
//         const response = await apiGet("agent_support_getall");
//         console.log("API Response:", response);
//         const supportsData = response.data || response;
//         setAgentSupports(supportsData);

//         // Don't auto-select any support item - keep right side empty initially
//       } catch (err) {
//         console.error("Error fetching agent supports:", err);
//       }
//     };

//     fetchAgentSupports();
//   }, []);

//   // Filter agent supports based on search
//   const filteredAgentSupports = agentSupports.filter((item: any) =>
//     item.name.toLowerCase().includes(searchKeyword.toLowerCase()) ||
//     item.category.toLowerCase().includes(searchKeyword.toLowerCase()) ||
//     item.description.toLowerCase().includes(searchKeyword.toLowerCase()) ||
//     item.ticket.includes(searchKeyword)
//   );

//   return (
//     <>
//       <Breadcrumbs
//         pageTitle={AgentSupportTitle}
//         parent={Support}
//         title={AgentSupportTitle}
//       />
//       <Row className="g-0">
//         <Col xxl={3} xl={4} md={5} className="box-col-5">
//           <Card className="left-sidebar-wrapper">
//             <div className="left-sidebar-chat">
//               <InputGroup>
//                 <InputGroupText>
//                   <Search className="search-icon text-gray" />
//                 </InputGroupText>
//                 <Input
//                   type="text"
//                   placeholder="Search here.."
//                   value={searchKeyword}
//                   onChange={(e) => handleSearchKeyword(e.target.value)}
//                 />
//               </InputGroup>
//             </div>
//             <div className="advance-options">
//               <TabContent activeTab={activeTab}>
//                 <TabPane tabId={1}>
//                   <>
//                     {filteredAgentSupports && filteredAgentSupports.length > 0 ? (
//                       <UL className="chats-user simple-list">
//                         {filteredAgentSupports.map((item: any, i: number) => {
//                           return (
//                             <LI
//                               key={i}
//                               className={`common-space ${
//                                 activeChat === item.id && "active"
//                               }`}
//                               onClick={() => changeChatClick(item)}
//                             >
//                               <div className="chat-time">
//                                 <div className="active-profile">
//                                   <Image
//                                     src={dynamicImage("userpic.png")}
//                                     className="img-fluid rounded-circle"
//                                     alt=""
//                                   />
//                                 </div>
//                                 <div>
//                                   <span>{item.name}</span>
//                                   <P>{item.description}</P>
//                                 </div>
//                               </div>
//                               <div>
//                                 <P>{item.ticket}</P>
//                                 <Badges color="light-success">
//                                   {item.category}
//                                 </Badges>
//                               </div>
//                             </LI>
//                           );
//                         })}
//                       </UL>
//                     ) : (
//                       <div className="text-center">{"No Agent Support Present"}</div>
//                     )}
//                   </>
//                 </TabPane>
//               </TabContent>
//             </div>
//           </Card>
//         </Col>
//         <Col xxl={9} xl={8} md={7} className="box-col-7">
//           <Card className="right-sidebar-chat">
//             {selectedSupport ? (
//               // Show chat interface when support ticket is selected
//               <>
//                 <div className="right-sidebar-title">
//                   <div className="support-ticket-header p-3 border-bottom">
//                     {/* Main Header Row */}
//                     <div className="d-flex justify-content-between align-items-start mb-3">
//                       <div className="d-flex align-items-center">
//                         <div className="active-profile me-3">
//                           <Image
//                             className="img-fluid rounded-circle"
//                             src={dynamicImage("profile.png")}
//                             alt="user"
//                             style={{ width: "50px", height: "50px" }}
//                           />
//                         </div>
//                         <div>
//                           <h5 className="mb-1">{selectedSupport.name}</h5>
//                           <div className="d-flex align-items-center gap-2">
//                             <span className="badge bg-primary">#{selectedSupport.ticket}</span>
//                             <span className={`badge ${
//                               selectedSupport.status === 'New' ? 'bg-success' :
//                               selectedSupport.status === 'In Progress' ? 'bg-warning' :
//                               selectedSupport.status === 'Resolved' ? 'bg-info' :
//                               'bg-secondary'
//                             }`}>
//                               {selectedSupport.status}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="d-flex gap-2">
//                         <div className="contact-edit chat-alert">
//                           <i className="icon-info-alt" />
//                         </div>
//                         <div className={`contact-edit chat-alert`}>
//                           <Dropdown isOpen={dropdownOpen} toggle={toggle}>
//                             <DropdownToggle
//                               color="transparent"
//                               className="d-flex align-items-center"
//                             >
//                               <MoreVertical />
//                             </DropdownToggle>
//                             <DropdownMenu end={true}>
//                               <DropdownItem href={Href}>
//                                 {"View details"}
//                               </DropdownItem>
//                               <DropdownItem href={Href}>
//                                 {"Send messages"}
//                               </DropdownItem>
//                               <DropdownItem href={Href}>
//                                 {"Add to favorites"}
//                               </DropdownItem>
//                             </DropdownMenu>
//                           </Dropdown>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Ticket Details Row */}
//                     <div className="ticket-details">
//                       <div className="row g-3">
//                         <div className="col-md-8">
//                           <div className="card bg-light border-0 p-2">
//                             <div className="d-flex align-items-start">
//                               <div className="me-2">
//                                 <i className="fa-solid fa-tag text-primary"></i>
//                               </div>
//                               <div className="flex-grow-1">
//                                 <small className="text-muted fw-bold">Category</small>
//                                 <p className="mb-1">{selectedSupport.category}</p>
//                                 <small className="text-muted fw-bold">Description</small>
//                                 <p className="mb-0 text-break">{selectedSupport.description}</p>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                         <div className="col-md-4">
//                           <div className="card bg-light border-0 p-2 h-100">
//                             <div className="d-flex flex-column h-100">
//                               <div className="mb-2">
//                                 <small className="text-muted fw-bold">Created</small>
//                                 <p className="mb-0 small">
//                                   {new Date(selectedSupport.created_at).toLocaleDateString()} at{' '}
//                                   {new Date(selectedSupport.created_at).toLocaleTimeString([], {
//                                     hour: '2-digit',
//                                     minute: '2-digit'
//                                   })}
//                                 </p>
//                               </div>
//                               {selectedSupport.file && (
//                                 <div className="mt-auto">
//                                   <small className="text-muted fw-bold">Attachment</small>
//                                   <div className="d-flex align-items-center">
//                                     <i className="fa-solid fa-paperclip text-success me-1"></i>
//                                     <small
//                                       className="text-success text-decoration-underline cursor-pointer text-truncate"
//                                       style={{ maxWidth: "120px" }}
//                                       title={selectedSupport.file}
//                                     >
//                                       {selectedSupport.file.split('/').pop() || selectedSupport.file}
//                                     </small>
//                                      <img
//                                               src={`${mediaUrl}/${selectedSupport.file}`}
//                                               alt={selectedSupport.file}
//                                               width={25}
//                                               height={25}
//                                               style={{
//                                                 objectFit: "cover",
//                                                 borderRadius: "10px",
//                                               }}
//                                             />
//                                   </div>
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="right-sidebar-Chats">
//                   <div className="msger">
//                     <div className="msger-chat" ref={chatHistoryRef}>
//                       {agentChat && agentChat.length > 0 ? (
//                         agentChat.map((item: any, index: number) => {
//                           const isAgent = item.agent_id !== null;
//                           return (
//                             <div
//                               className={`msg ${
//                                 isAgent ? "left" : "right"
//                               }-msg`}
//                               key={index}
//                             >
//                               <div className="msg-img">
//                                 <Image
//                                   src={dynamicImage(
//                                     isAgent ? "userpic.png" : "profile.png"
//                                   )}
//                                   className={`rounded-circle ${
//                                     isAgent ? "float-start" : "float-end"
//                                   } chat-user-img img-30 h-auto`}
//                                   alt=""
//                                 />
//                               </div>
//                               <div className="msg-bubble">
//                                 <div className="msg-info">
//                                   <div className="msg-info-name">
//                                      {isAgent ? (selectedSupport?.name || "Agent") : "Admin"}
//                                   </div>
//                                   <div className="msg-info-time">
//                                     {new Date(item.created_at).toLocaleTimeString()}
//                                   </div>
//                                 </div>
//                                 <div className="msg-text">{item.message}</div>
//                               </div>
//                             </div>
//                           );
//                         })
//                       ) : (
//                         <div className="text-center p-4">
//                           <Image
//                             className="img-fluid mb-3"
//                             src={dynamicImage("start-conversion.jpg")}
//                             alt="start conversation"
//                             style={{ maxWidth: "200px" }}
//                           />
//                           <h5>Start the conversation</h5>
//                           <p className="text-muted">Send a message to begin support chat</p>
//                         </div>
//                       )}
//                       <div ref={bottomRef}></div>
//                     </div>
//                     <Form
//                       className="msger-inputarea"
//                       onSubmit={(e) => handleSubmit(e)}
//                     >
//                       <Dropdown isOpen={dropdown} toggle={toggledrop}>
//                         <DropdownToggle
//                           className="dropdown-form p-0"
//                           color="transparent"
//                         >
//                           <i className="icon-plus" />
//                         </DropdownToggle>
//                         <DropdownMenu className="chat-icon" start="true">
//                           <DropdownItem tag="div" className="mb-2">
//                             <DashboardSvgIcon iconId="camera" />
//                           </DropdownItem>
//                           <DropdownItem tag="div">
//                             <DashboardSvgIcon iconId="attchment" />
//                           </DropdownItem>
//                         </DropdownMenu>
//                       </Dropdown>
//                       <Input
//                         type="text"
//                         className="msger-input two uk-textarea"
//                         placeholder="Type a message......"
//                         value={messageInput}
//                         onChange={(e) => handleMessageChange(e.target.value)}
//                       />
//                       <div>
//                         {showEmojiPicker ? (
//                           <EmojiPicker onEmojiClick={(e) => addEmoji(e.emoji)} />
//                         ) : null}
//                       </div>
//                       <div className="open-emoji">
//                         <div
//                           className="second-btn uk-button"
//                           onClick={() => setShowEmojiPicker(!showEmojiPicker)}
//                         />
//                       </div>
//                       <Btn
//                         color="primary"
//                         className="msger-send-btn"
//                         disabled={!messageInput.trim()}
//                       >
//                         <i className="fa-solid fa-location-arrow" />
//                       </Btn>
//                     </Form>
//                   </div>
//                 </div>
//               </>
//             ) : (
//               // Show empty state when no support ticket is selected (like WhatsApp Web)
//               <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center p-5">
//                 <div className="mb-4">
//                   <i className="fa-solid fa-comments" style={{ fontSize: "4rem", color: "#ddd" }}></i>
//                 </div>
//                 <h3 className="mb-3 text-muted">Agent Support Chat</h3>
//                 <p className="text-muted mb-4" style={{ maxWidth: "400px" }}>
//                   Select a support ticket from the list to start viewing and responding to customer inquiries.
//                 </p>
//
//               </div>
//             )}
//           </Card>
//         </Col>
//       </Row>
//     </>
//   );
// }
